function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FunctionalLoader } from 'seagull';
import HomePage from "../HomePage/HomePage";
import Notification from "../Notification/Notification";
import { SignupScreen, ResetPasswordScreen, SetPasswordScreen, LoginScreen } from "../unAuthorizedPages";
import AgreementStudio from "../../components/AgreementStudio/AgreementStudio";
import RelationshipDraftFetcher from "../../components/AgreementStudio/RelationshipDraftFetcher";
import AgreementMinisite from "../AgreementMinisite/AgreementMinisite";
import { useStore } from "../../contexts";
import ImpersonateWarning from "../../components/ImpersonateWarning/ImpersonateWarning";
import CanceledProposalPage from "../../components/CanceledProposalPage/CanceledProposalPage";
import FeatureFlagsGuard from "../../components/FeatureFlagsGuard/FeatureFlagsGuard";
import ClientOnboarding from "../../client-flow/clientOb/ClientOnboarding";
import { RedirectPage } from "../RedirectPage";
import { routes } from "../../constants";
import { useEventReporter } from "../../event-reporter";
import KycStatusBinder from "../../components/KycStatusBinder";
import FeatureFlagsFetcher from "../../components/FeatureFlagsFetcher/FeatureFlagsFetcher";
import 'seagull/foundations/font-face.scss';
import { selectors } from "../../store/state-selectors";
import AgreementStudioTemplates from "../../components/AgreementStudio/AgreementStudioTemplates";
import ProposalTemplateLoader from "../../components/ProposalTemplateLoader";
import { useSyncUserDataBetweenTabs } from "../../hooks/useSyncUserDataBetweenTabs";
import { useSessionTimeout } from "../../hooks/useSessionTimeout";
import MainPages from "./MainPages";
import { withOptimizedMobileViewport } from "../../providers/MobileViewportWidthProvider";
import { withBlockPartiallyOnboardedVendor } from "../../components/withBlockPartiallyOnboardedVendor/withBlockPartiallyOnboardedVendor";
import NoPermissionsRelationshipApproved from "../../client-flow/clientOb/AllSetStep/noPermissionsRelationshipApproved";
import RelationshipApprovedWithAnimations from "../../client-flow/clientOb/RelationshipSignedStep/RelationshipApprovedWithAnimations";
import AllSetPage from "../../client-flow/clientOb/AllSetStep/AllSetPage";
import AdditionalPaymentProcessorInfoPage from "../AdditionalPaymentProcessorInfoPage/AdditionalPaymentProcessorInfoPage";
import ExpiredProposalPage from "../../components/ExpiredProposalPage/ExpiredProposalPage";
import { NotificationActionPage } from "../NotificationAction";
import NoAccessPage from "../NoAccessPage/NoAccessPage";
import { BusinessPartyTypeEnum } from "../../store/store.model";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const unauthorizedPages = [{
  url: routes.signUp,
  component: SignupScreen
}, {
  url: routes.setPassword,
  component: SetPasswordScreen
}, {
  url: routes.resetPassword,
  component: ResetPasswordScreen
}, {
  url: routes.notification(),
  component: Notification
}, {
  url: routes.noPermissionsRelationshipAlreadyApproved,
  component: NoPermissionsRelationshipApproved
}, {
  url: routes.allSignaturesAcquired,
  component: RelationshipApprovedWithAnimations
}, {
  url: routes.expiredProposalPage,
  component: ExpiredProposalPage,
  supportsMobile: true
}, {
  url: routes.canceledProposalPage,
  component: CanceledProposalPage,
  supportsMobile: true
}, {
  url: routes.additionalPaymentProcessorInfo,
  component: AdditionalPaymentProcessorInfoPage
}, {
  url: routes.notificationAction,
  component: NotificationActionPage,
  supportMobile: true
}, {
  url: routes.noAccessPage,
  component: NoAccessPage,
  supportsMobile: true
}].map(config => _objectSpread(_objectSpread({}, config), {}, {
  component: withOptimizedMobileViewport(config.component)
}));
const authorizedPages = [{
  url: routes.redirect,
  component: RedirectPage,
  supportsMobile: true,
  allowPartiallyOnboardedVendor: true
}, {
  url: routes.home,
  component: HomePage,
  allowPartiallyOnboardedVendor: true
}, {
  url: routes.agreementStudio,
  component: AgreementStudio,
  vendorOnly: true
}, {
  url: routes.proposalTemplateStudio,
  component: AgreementStudioTemplates
}, {
  url: routes.minisite(),
  component: AgreementMinisite
}, {
  url: routes.draft(),
  component: RelationshipDraftFetcher,
  vendorOnly: true
}, {
  url: routes.proposalTemplate(),
  component: ProposalTemplateLoader
}, {
  url: routes.clientOnboarding(),
  component: ClientOnboarding,
  supportsMobile: true
}, {
  url: routes.allSet(),
  component: AllSetPage,
  supportsMobile: true
}].map(config => {
  if (config.supportsMobile) {
    config.component = withOptimizedMobileViewport(config.component);
  }
  if (!config.allowPartiallyOnboardedVendor) {
    config.component = withBlockPartiallyOnboardedVendor(config.component);
  }
  return config;
});
const BeforeAuthFlowDone = withOptimizedMobileViewport(() => /*#__PURE__*/_jsx(FunctionalLoader, {
  name: "waitForAuthFlowDone",
  show: true
}));
const LoggedOutComponent = withOptimizedMobileViewport(LoginScreen);
export default function Main() {
  const hasUserInfo = useStore(selectors.user.hasUserInfo);
  const isResetPasswordFlow = useStore(selectors.isResetPasswordFlow);
  const hasAuthToken = useStore(state => state.authToken != null);
  const authFlowDone = useStore(state => state.authFlowDone);
  const worksAt = useStore(selectors.user.business);
  const isWaitingForUserInfo = hasAuthToken && !isResetPasswordFlow && !hasUserInfo;
  const location = useLocation();
  const {
    reportPageView
  } = useEventReporter();
  useSyncUserDataBetweenTabs();
  useSessionTimeout();
  useEffect(() => {
    reportPageView(location.pathname, (worksAt === null || worksAt === void 0 ? void 0 : worksAt.type) == BusinessPartyTypeEnum.Vendor, worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
  }, [location, worksAt]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(KycStatusBinder, {}), /*#__PURE__*/_jsx(FeatureFlagsFetcher, {}), /*#__PURE__*/_jsx(ImpersonateWarning, {}), /*#__PURE__*/_jsx(FunctionalLoader, {
      name: "waitingForUserInfo",
      show: isWaitingForUserInfo
    }), authFlowDone ? /*#__PURE__*/_jsx(FeatureFlagsGuard, {
      children: /*#__PURE__*/_jsx(MainPages, {
        authorizedPages: authorizedPages,
        unauthorizedPages: unauthorizedPages,
        LoggedOutComponent: LoggedOutComponent
      })
    }) : /*#__PURE__*/_jsx(BeforeAuthFlowDone, {})]
  });
}